/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  // ============================================================
  // ONETURTLE 1: spamveilig e-mailadres
  // Pagina's bevatten de marker [email] in plaats van een e-mailadres in platte
  // tekst (spambots oogsten adressen uit de HTML-broncode). Dit script bouwt het
  // adres client-side op en vervangt de marker in TEKSTKNOPEN door een klikbare
  // mailto-link. Let op: alleen tekstknopen, nooit attributen of formuliervelden
  // (het e-mailveld van het contactformulier heet intern 'contact[email]').
  // ============================================================
  function insertEmailLinks() {
    var parts = ['support', 'oneturtle', 'shop'];
    var addr = parts[0] + '@' + parts[1] + '.' + parts[2];
    var main = document.querySelector('#MainContent');
    if (!main || !window.document.createTreeWalker) return;
    var walker = document.createTreeWalker(main, NodeFilter.SHOW_TEXT, null);
    var nodes = [];
    var n;
    while ((n = walker.nextNode())) {
      if (n.nodeValue && n.nodeValue.indexOf('[email]') !== -1) nodes.push(n);
    }
    for (var i = 0; i < nodes.length; i++) {
      var node = nodes[i];
      var pieces = node.nodeValue.split('[email]');
      var frag = document.createDocumentFragment();
      for (var j = 0; j < pieces.length; j++) {
        frag.appendChild(document.createTextNode(pieces[j]));
        if (j < pieces.length - 1) {
          var a = document.createElement('a');
          a.href = 'mailto:' + addr;
          a.textContent = addr;
          frag.appendChild(a);
        }
      }
      node.parentNode.replaceChild(frag, node);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', insertEmailLinks);
  } else {
    insertEmailLinks();
  }

  // ============================================================
  // ONETURTLE 2: Nederlandse tekst voor de ParcelPanel track & trace-pagina
  // (/nl/apps/parcelpanel). De vaste app-teksten vertaalt ParcelPanel zelf; de
  // eigen welkomsttekst (div.pp_tracking_below) en de titel worden hier vertaald.
  // Met retries + MutationObserver omdat de app content asynchroon plaatst.
  // ============================================================
  var EN_SNIPPET = 'Welcome to our Track and Trace Service';
  var NL_TRACK_TEXT = 'Welkom bij onze Track & Trace-service! We begrijpen hoe belangrijk het voor je is om te weten waar je pakket is. Daarom zorgen we voor realtime updates en directe toegang tot alle trackinginformatie. Hier volg je moeiteloos elke stap van de reis van jouw bestelling. Jouw vertrouwen en gemoedsrust staan bij ons voorop. Bedankt dat je jouw waardevolle pakket aan ons toevertrouwt.';
  var TITLE_FROM = 'Volg uw bestelling';
  var TITLE_TO = 'Volg jouw bestelling';

  function isNlTrackingPage() {
    var p = window.location.pathname;
    return p.indexOf('/nl') === 0 && p.indexOf('/apps/parcelpanel') !== -1;
  }

  function applyNlTrackingText() {
    var el = document.querySelector('.pp_tracking_below');
    if (el) {
      if (el.textContent && el.textContent.indexOf(EN_SNIPPET) !== -1) {
        el.textContent = NL_TRACK_TEXT;
      }
    } else {
      var els = document.querySelectorAll('#MainContent *');
      var candidates = [];
      for (var i = 0; i < els.length; i++) {
        if (els[i].textContent && els[i].textContent.indexOf(EN_SNIPPET) !== -1) candidates.push(els[i]);
      }
      if (candidates.length) candidates[candidates.length - 1].textContent = NL_TRACK_TEXT;
    }
    var all = document.querySelectorAll('#MainContent *');
    for (var j = 0; j < all.length; j++) {
      var t = all[j];
      if (t.tagName === 'SCRIPT' || t.tagName === 'STYLE') continue;
      if (t.children.length === 0 && t.textContent && t.textContent.indexOf(TITLE_FROM) !== -1) {
        t.textContent = t.textContent.replace(TITLE_FROM, TITLE_TO);
      }
    }
  }

  function startNlTrackingSwap() {
    applyNlTrackingText();
    var tries = 0;
    var timer = setInterval(function() {
      tries++;
      applyNlTrackingText();
      if (tries > 30) clearInterval(timer);
    }, 500);
    var main = document.querySelector('#MainContent');
    if (main && window.MutationObserver) {
      new MutationObserver(function() { applyNlTrackingText(); })
        .observe(main, { childList: true, subtree: true, characterData: true });
    }
  }

  if (isNlTrackingPage()) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', startNlTrackingSwap);
    } else {
      startNlTrackingSwap();
    }
  }

  // ============================================================
  // ONETURTLE 3: mega-menu OVER ONS (desktop)
  // Stylet de 3 fotokaarten in de OVER ONS-dropdown: linkskolom verborgen,
  // kaarten in een GRID van exact 3 kolommen van 340px met 20px tussenruimte
  // (grid dwingt gelijke maten en gelijke gaten af, ongeacht thememargins),
  // 32px lucht boven en onder, geen zwarte gloed maar een subtiele
  // tekstschaduw. Via klasse ot-about-mega + eigen stylesheet zodat het in
  // elke browser werkt; met retries + observer omdat het thema de header
  // (sticky) later opnieuw kan opbouwen.
  // ============================================================
  function otAboutMegaTag() {
    var links = document.querySelectorAll('.header__dropdown .menu__blocks a[href*="how-it-works"]');
    for (var i = 0; i < links.length; i++) {
      var el = links[i];
      while (el && el !== document.body) {
        if (el.classList && el.classList.contains('header__dropdown')) {
          if (!el.classList.contains('ot-about-mega')) el.classList.add('ot-about-mega');
          break;
        }
        el = el.parentElement;
      }
    }
  }

  function otAboutMegaCss() {
    if (document.getElementById('ot-about-mega-css')) return;
    var st = document.createElement('style');
    st.id = 'ot-about-mega-css';
    st.textContent =
      '.ot-about-mega .header__grandparent__links{display:none!important}' +
      '.ot-about-mega .header__dropdown__inner{display:flex!important;justify-content:center!important;padding-top:32px!important;padding-bottom:32px!important}' +
      '.ot-about-mega .menu__blocks{display:grid!important;grid-template-columns:340px 340px 340px!important;gap:20px!important;justify-content:center!important;flex:0 0 auto!important;margin:0 auto!important;width:auto!important;max-width:none!important}' +
      '.ot-about-mega .menu__block{width:340px!important;max-width:340px!important;margin:0!important;padding:0!important}' +
      '.ot-about-mega .menu__block .header__dropdown__image{width:340px!important;height:272px!important;overflow:hidden!important;position:relative!important;margin:0!important}' +
      '.ot-about-mega .menu__block .image-wrapper{width:340px!important;height:272px!important;padding-top:0!important}' +
      '.ot-about-mega .menu__block .image-wrapper img{position:absolute;top:0;left:0;width:100%!important;height:100%!important;object-fit:cover!important}' +
      '.ot-about-mega .menu__block .hero__content:before{display:none!important;background:none!important}' +
      '.ot-about-mega .menu__block .hero__title,.ot-about-mega .menu__block .hero__description{text-shadow:0 1px 6px rgba(0,0,0,0.45)!important}';
    document.head.appendChild(st);
  }

  function otAboutMega() {
    otAboutMegaCss();
    otAboutMegaTag();
    var tries = 0;
    var timer = setInterval(function() {
      tries++;
      otAboutMegaTag();
      if (tries > 20) clearInterval(timer);
    }, 500);
    if (window.MutationObserver) {
      new MutationObserver(function() { otAboutMegaTag(); })
        .observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', otAboutMega);
  } else {
    otAboutMega();
  }

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
